module.exports = require("@swa-ui/itinerary/src/FlightNumber/FlightNumber.module.scss");